import { AssetsData } from '@/types/asset';

export default class ProductUtils {
  private product: AssetsData;
  constructor(product: AssetsData) {
    this.product = product;
  }

  getProductLabel() {
    if (!this.product || !this.product.expiryStatus) {
      return '';
    }

    const {
      expiryStatus: { status, isAboutToExpire },
    } = this.product;
    if (status == 'IC' && isAboutToExpire) {
      return 'AMC Expiring';
    } else if (status === 'IC' && !isAboutToExpire) {
      return 'AMC Tier';
    } else if (status == 'IW' && isAboutToExpire) {
      return 'Warranty Expiring';
    } else if (status === 'IW' && !isAboutToExpire) {
      return 'In Warranty';
    } else {
      return '';
    }
  }
}
